import { startGame } from '@fg/base/main';
import { Scene } from '@fg/base/scene';
import { AlignGrid } from '@fg/base/phaser_utilities/align_grid';
import store from '@fg/base/store';
class GameScene extends Scene {
    update() {
        super.update();
    }

    init() {
        super.init();

        this.mainSound = this.sound.add('mus_basegame', {"loop":true, "volume": 0.5});
        this.mainSound.play();

        store.commit('toggleExplanation', {
            callback: () => {
                this.letInitialize(() => {
                    this.prepareSounds();
                    this.properties();
                    this.positionerContainer = this.add.rexContainerLite();
                    this.createBg();
                    this.createGameItems();
                    this.createFader();
                    this.createBonus2();
                    this.spritesReady = true;
                    this.baseGamePositioner();
                    this.canvasReady();
                });
            }
        });
    }

    afterPurchase() {
        this.loadSymbols();
    }

    beforePurchase() {
        this.sound.play('sfx_btn_play');
    }

    prepareSounds() {

        this.bonusSound = this.sound.add('mus_bonus', {"loop":true, "volume": 0});

        this.multiplierSpinSound = this.sound.add('sfx-multiplier-spin', {"loop":true, "volume": 1});

        this.pointCountSound = this.sound.add('sfx-point-count', {"loop":true, "volume": 1});
    }

    loadSymbols() {
        this.scrollsFound = 0;
        this.urnsWillOpenCount = 0;
        this.rowsOpened = 0;
        this.rowsWillBeOpened = 0;
        this.bonus1Mapped = {};
        this.bonus1Opened = {};
        this.countingAmount = 0;
        this.bonusWinAmount = 0;
        this.bonusLoadedAmount = 0;
        this.countingDelay = 0;
        this.icrementationDelay = 100;

        if(this.request.scenario.bonus_1) {
            for (const [key, value] of Object.entries(this.request.scenario.bonus_1)) {
                if(!this.bonus1Mapped[value.index]) {
                    this.bonus1Mapped[value.index] = {};
                    this.bonus1Opened[value.index] = 0;
                }

                this.bonus1Mapped[value.index][value.symbol_index] = value.symbol;
            }
        }

        this.tweens.add({
            targets: this.fullFaderMain,
            alpha: 0,
            ease: 'Power0',
            duration: 500,
        });

        this.tweens.add({
            targets:  this.mainSound,
            volume:   1,
            duration: 500
        });

        this.afterPurchaseAnimation();
    }

    afterPurchaseAnimation() {
        this.sound.play('sfx_game_appears');

        if(this.request.gamePlayedTimes > 0) {
            this.resetGame();
            this.slideInSymbols();
        } else {
            this.slideOutSymbols();
        }
    }

    resetGame() {
        for (let [rowIndex, row] of Object.entries(this.itemsRows)) {
            this.children.bringToTop(row.winCounterFxLoop);
            this.children.bringToTop(row.amount);
            this.children.bringToTop(row.slider)

            row.slider.slidedOut = false;

            this.children.bringToTop(row.sliderWinFrame);
            row.sliderWinFrame.setAlpha(0);
            this.children.bringToTop(row.sliderHover);
            this.children.bringToTop(row.winCounterFx);
            
            for (let [symbolKey, symbolItems] of Object.entries(row.symbols)) {
                this.children.bringToTop(symbolItems.symbol);
                this.children.bringToTop(symbolItems.symbolsShuffle);
                this.children.bringToTop(symbolItems.winFxLoop);
                this.children.bringToTop(symbolItems.winCounterFx);
                this.children.bringToTop(symbolItems.scarabAppear);
                this.children.bringToTop(symbolItems.scarabHover);

                symbolItems.symbol.setTexture('');
                symbolItems.symbol.setAlpha(0);
                symbolItems.symbolsShuffle.setAlpha(0);
                symbolItems.winFxLoop.setAlpha(0);
                symbolItems.winCounterFx.setAlpha(0);
                symbolItems.symbolsShuffle.setAlpha(0);
            }
        }
        
        for (let [rowIndex, row] of Object.entries(this.bonus2Rows)) {
            for (let [urnKey, urn] of Object.entries(row.urns)) {
                urn.opened = false;
                urn.amount.setText(General.format_currency(0));
                urn.amount.setStyle(this.fonts.urnsAmounts);
                
                this.bonus2Container.setChildLocalAlpha(urn.winCounterFxLoop, 0);
                this.bonus2Container.setChildLocalAlpha(urn.amount, 0);
                this.bonus2Container.setChildLocalAlpha(urn.over, 0);
                urn.setFrame(0);
            }
        }

        this.urnFrameActive2.setAlpha(0);
        this.urnMultiplier2.setAlpha(0);
        this.urnMultiplier2.setText('x0');
        this.bonus2WonText.setAlpha(0);
        this.bonus2WonFrame.setAlpha(0);
        this.bonus2WonAmount.setAlpha(0);
        this.bonus2WonAmount.setText(General.format_currency(0, true));
    }

    slideOutSymbols() {
        const slideSpeed = 500;
        const tweenDelay = 50;
        const symbolDelayStep = 200;

        for(let i = 0; i < 3; i++) {
            let delay = tweenDelay * i + symbolDelayStep;

            this.tweens.add({
                targets: this.itemsRows[i].slider,
                x: (target) => {
                    return target.x + (this.orientationIsSetToPortrait() ? -(target.displayWidth) : target.displayWidth) ;
                },
                ease: 'Power0',
                duration: slideSpeed,
                delay
            });

            let symbolDelay = 0;

            for(let j = 0; j < 3; j++) {
                let symbol = this.itemsRows[i].symbols[(!this.orientationIsSetToPortrait() ? j : 2 - j)]

                symbol.scarabAppear.playReverse({
                    key: 'scarab_appear',
                    delay: (delay + symbolDelay)
                });

                symbol.scarabAppear.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                    symbol.scarabAppear.setAlpha(0);
                });

                symbolDelay += symbolDelayStep;
            }
        }

        for(let k = 3; k < 6; k++) {
            let delay = tweenDelay * (k-3) + symbolDelayStep;

            this.tweens.add({
                targets: this.itemsRows[k].slider,
                x: (target) => {
                    return target.x - target.displayWidth;
                },
                ease: 'Power0',
                duration: slideSpeed,
                delay
            });

            let symbolDelay = 0;

            for(let l = 2; l >= 0; l--) {
                let symbol = this.itemsRows[k].symbols[l]

                symbol.scarabAppear.playReverse({
                    key: 'scarab_appear',
                    delay: (delay + symbolDelay)
                });
                
                if(k === 5 && !l) {
                    symbol.scarabAppear.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                        symbol.scarabAppear.setAlpha(0);
                        this.slideInSymbols();
                    });
                } else {
                    symbol.scarabAppear.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                        symbol.scarabAppear.setAlpha(0);
                    });
                }

                symbolDelay += symbolDelayStep;
            }
        }
    }

    slideInSymbols() {
        const slideSpeed = 500;
        const tweenDelay = 50;
        const symbolDelayStep = 200;

        for(let i = 0; i < 3; i++) {
            let delay = tweenDelay * i;

            this.itemsRows[i].opened = false;

            this.itemsRows[i].slider.tween = this.tweens.add({
                targets: this.itemsRows[i].slider,
                x: (target) => {
                    return target.originalX;
                },
                ease: 'Power0',
                duration: slideSpeed,
                delay,
                onComplete : () => {
                    this.itemsRows[i].amount.setStyle(this.fonts.amount);
                    this.addAmountGradient(this.itemsRows[i].amount);
                    this.itemsRows[i].amount.setText(General.format_currency(0));
                    this.itemsRows[i].amount.setAlpha(0);
                    this.itemsRows[i].winCounterFxLoop.setAlpha(0);
                    this.itemsRows[i].winCounterFx.setAlpha(0);
                    store.commit('showOpenAllButton');
                }
            });

            let symbolDelay = 0;
            let h = 0;

            for(let j = 2; j >= 0; j--) {
                let symbol = this.itemsRows[i].symbols[(!this.orientationIsSetToPortrait() ? j : h)];

                symbol.scarabAppear.playAfterDelay('scarab_appear', (delay + symbolDelay));
                
                this.time.delayedCall((delay + symbolDelay), () => {
                    symbol.scarabAppear.setAlpha(1);
                });

                symbolDelay += symbolDelayStep;

                h++;
            }
        }
        
        for(let k = 3; k < 6; k++) {
            let delay = tweenDelay * (k-3);

            this.itemsRows[k].opened = false;

            this.itemsRows[k].slider.tween = this.tweens.add({
                targets: this.itemsRows[k].slider,
                x: (target) => {
                    return target.originalX;
                },
                ease: 'Power0',
                duration: slideSpeed,
                delay,
                onComplete : () => {
                    this.itemsRows[k].amount.setStyle(this.fonts.amount);
                    this.addAmountGradient(this.itemsRows[k].amount);
                    this.itemsRows[k].amount.setText(General.format_currency(0));
                    this.itemsRows[k].amount.setAlpha(0);
                    this.itemsRows[k].winCounterFxLoop.setAlpha(0);
                    this.itemsRows[k].winCounterFx.setAlpha(0);
                }
            });

            let symbolDelay = 0;

            for(let l = 0; l < 3; l++) {
                let symbol = this.itemsRows[k].symbols[l]
                
                symbol.scarabAppear.playAfterDelay('scarab_appear', (delay + symbolDelay));

                this.time.delayedCall((delay + symbolDelay), () => {
                    symbol.scarabAppear.setAlpha(1);
                });
                
                if(k === 5 && l == 2) {
                    symbol.scarabAppear.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                        this.countinueMainGame();
                        this.addInputs();
                    });
                }
                
                symbolDelay += symbolDelayStep;
            }
        }
    }

    addInputs() {
        for (let [rowIndex, row] of Object.entries(this.itemsRows)) {
            for (let [symbolKey, symbolItems] of Object.entries(row.symbols)) {
                const symbol = symbolItems.scarabAppear;
                this.addInput(row, rowIndex, symbol);
            }

            this.addInput(row, rowIndex, row.slider);
        }
    }

    countinueMainGame() {
        this.runMultiplier();
        this.openingRow = false;
    }

    addInput(row, rowIndex, symbol) {
        symbol.setInteractive({ cursor: 'pointer', pixelPerfect: true})
        .on('pointerup', () => {
            this.toggleHovers(row, false);
            this.openRow(row, rowIndex);
        })
        .on('pointerover', () => {
            symbol.pointerOn = true;
            this.toggleHovers(row, true);
        })
        .on('pointerout', () => {
            symbol.pointerOn = false;

            this.time.delayedCall(5, () => {
                let pointerOnSymbols = 0;

                for (let [symbolKey, symbolItems] of Object.entries(row.symbols)) {
                    if(symbolItems.scarabAppear.pointerOn) {
                        pointerOnSymbols++;
                    }
                }

                if(row.slider.pointerOn) {
                    pointerOnSymbols++;
                }

                if(!pointerOnSymbols) {
                    this.toggleHovers(row, false);
                }
            }, {}, this);
        });
    }

    toggleHovers(row, show) {
        if(show && row.animationsIsPlaying) {
            return;
        }

        if(show) {
            row.animationsIsPlaying = true;

            if(!row.sliderHover.anims.isPlaying) {
                row.sliderHover.play('slider_hover');
                row.sliderHover.setAlpha(1);
                
                this.sound.play('sfx-hover');
            }
        } else {
            row.animationsIsPlaying = false;
            row.sliderHover.stop();
            row.sliderHover.setAlpha(0);
        }

        for (let [symbolKey, symbolItems] of Object.entries(row.symbols)) {
            if(show) {
                if(!symbolItems.scarabHover.anims.isPlaying) {
                    symbolItems.scarabHover.setAlpha(1);
                    symbolItems.scarabHover.play('scarab_hover');
                }
            } else {
                symbolItems.scarabHover.stop();
                symbolItems.scarabHover.setAlpha(0);
            }
        }
    }

    openAll() {
        for (let [rowIndex, row] of Object.entries(this.itemsRows)) {
            this.openRow(row, rowIndex);
        }
    }

    openRow(row, rowIndex) {
        if(row.opened || this.openingRow) {
            return;
        }

        this.openingRow = true;
        row.opened = true;

        this.rowsWillBeOpened++;

        if (this.rowsWillBeOpened === 6) {
            store.commit('disableOpenAllButton');
        }

        let delay = 0;

        let toX = row.slider.x + (row.columnIndex === 1 && ! this.orientationIsSetToPortrait() ? row.slider.displayWidth / 2 : -( row.slider.displayWidth / 2));

        let amountWon = this.request.scenario['items'][rowIndex]['amount_before'] ? this.request.scenario['items'][rowIndex]['amount_before'] : this.request.scenario['items'][rowIndex]['amount'];
        let amountText = General.format_currency(amountWon);

        this.tweens.add({
            targets: row.slider,
            x: toX,
            ease: 'Power0',
            duration: 500,
        });

        row.slider.slidedOut = true;

        this.stopToMultiplier(this.request.scenario['items'][rowIndex].multiplier);

        row.amount.setText(amountText);
        row.amount.setStyle(this.fonts.amount);
        this.addAmountGradient(row.amount);
        this.customHelper.applyDynamicFontSize(row.amount, 200);

        row.amount.alpha = 1;
        
        let symbolOpening = 0;
        let urnsFound = [];
        let scrollsFound = [];

        this.customHelper.removeClickable(row.slider);

        let symbols = row.columnIndex === 1 && !this.orientationIsSetToPortrait() ? Object.entries(row.symbols).reverse() : Object.entries(row.symbols);

        for (let [symbolKey, symbolItems] of symbols) {
            const scarabAppear = symbolItems.scarabAppear;

            this.customHelper.removeClickable(scarabAppear);

            this.time.delayedCall(delay, () => {
                const randomSfx = Phaser.Math.RND.integerInRange(1, 3);
                this.sound.play(`sfx_reveal_${randomSfx}`);
            });

            scarabAppear.playAfterDelay('scarab_smash', delay);

            scarabAppear.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                scarabAppear.alpha = 0;
            });

            const symbol = symbolItems.symbol;
            const symbolName = this.request.scenario['items'][rowIndex]['symbols'][symbolKey];

            if(symbolName === 'scroll') {
                scrollsFound.push(symbol);
            }

            if(symbolName === 'urn') {
                urnsFound.push(symbol);
            }

            symbol.setTexture(`symbol_${symbolName}`);
            symbol.setAlpha(1);
            symbol.playAfterDelay(`symbol_${symbolName}`, delay);

            delay += 200;

            symbolOpening++;

            if(symbolOpening === 3) {
                symbol.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                    this.afterRowOpened(row, rowIndex, scrollsFound, urnsFound, amountWon);
                });
            }
        }
    }

    createFader() {
        this.fullFader = this.add.graphics().fillStyle(0x000000, 1).fillRect(0, 0, 1920, 1920);
        this.fullFader.setAlpha(0);

        this.fullFaderMain = this.add.graphics().fillStyle(0x000000, 1).fillRect(0, 0, 1920, 1920);
        this.fullFaderMain.setAlpha(0.4);
    }

    afterRowOpened(row, rowIndex, scrollsFound, urnsFound, amountWon) {
        if(!scrollsFound.length && !urnsFound.length) {
            if(this.request.scenario['items'][rowIndex]['lucky'] && ! this.request.scenario['items'][rowIndex]['changeable']) {
                this.markLuckySymbols(row, rowIndex, false, amountWon);
            } else {
                this.markOpenedSymbol();
            }

            return;
        }
        
        let delay = 0;
        let incrementer = 0;
        let callback = false;

        if(scrollsFound.length) {
            for (let symbol of scrollsFound) {
                symbol.playAfterDelay('symbol_scroll_win', delay);

                callback = (params) => {
                    this.scrollsFound++;    
                    this.scrollHits(this.scrollsFound, params.last);
                };

                this.flyParticleTo(
                    symbol.x, 
                    symbol.y, 
                    this.scrollIndicator.x,  
                    this.scrollIndicator.y,
                    delay, 
                    callback, 
                    {
                        last: (incrementer === scrollsFound.length-1 && !urnsFound.length)
                    }
                );

                callback = false;

                incrementer++;

                delay += 500;
            }
        }

        if(urnsFound.length) {
            callback = false;
            incrementer = 0;
            let urnsToHit = urnsFound.length * 2;
            
            for (let symbol of urnsFound) {
                symbol.playAfterDelay('symbol_urn_win', delay);

                for(let i = 0; i < 2; i++) {
                    this.urnsWillOpenCount++;
    
                    callback = (params) => {
                        this.urnHits(this.urnsWillOpenCount, params.last);
                    };
    
                    this.flyParticleTo(
                        symbol.x, 
                        symbol.y, 
                        this.urnFrame.x,  
                        this.urnFrame.y,
                        delay, 
                        callback,
                        {
                            last: (incrementer === urnsToHit-1)
                        }
                    )

                    delay += 150;

                    incrementer++;
                }

                callback = false;
            }

            delay += 500;
        }
    }

    markLuckySymbols(row, rowIndex, callback, amountWon) {
        let delay = 0;
        let symbolOpening = 0;

        let symbols = row.columnIndex === 1 && !this.orientationIsSetToPortrait() ? Object.entries(row.symbols).reverse() : Object.entries(row.symbols);

        for (let [symbolKey, symbolItems] of symbols) {
            const symbol = symbolItems.symbol;
            let symbolName = this.request.scenario['items'][rowIndex]['symbols'][symbolKey];

            if(this.request.scenario['items'][rowIndex]['changeable'] && this.bonus1Mapped[rowIndex] && this.bonus1Mapped[rowIndex][symbolKey]) {
                symbolName = this.bonus1Mapped[rowIndex][symbolKey];
            }

            symbol.setTexture(`symbol_${symbolName}_win`);
            symbol.playAfterDelay(`symbol_${symbolName}_win`, delay);
        
            this.time.delayedCall(delay, () => {
                const randomSfx = Phaser.Math.RND.integerInRange(1, 3);
                this.sound.play(`sfx_lightup_${randomSfx}`);
            });

            symbolItems.winCounterFx.playAfterDelay('win_counter_fx', delay);
            symbolItems.winFxLoop.playAfterDelay('win_fx_loop', delay);
            
            if(!delay) {
                symbolItems.winFxLoop.setAlpha(1);
                symbolItems.winCounterFx.setAlpha(1);
            } else {
                symbolItems.winFxLoop.once(Phaser.Animations.Events.ANIMATION_START, () => {
                    symbolItems.winFxLoop.setAlpha(1);
                    symbolItems.winCounterFx.setAlpha(1);
                });
            }

            delay += 200;

            symbolOpening++;
            
            symbolItems.winCounterFx.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                symbolItems.winCounterFx.setAlpha(0);
            });
        }

        const amount = row.amount;
        const middleOfAmount = amount.x + (amount.displayWidth / 2 * (amount.originX === 0 ?  1 :  -1));

        row.winCounterFx.setX(middleOfAmount);
        row.winCounterFxLoop.setX(middleOfAmount);

        row.winCounterFx.playAfterDelay('win_counter_fx', delay);
        row.winCounterFxLoop.playAfterDelay('win_counter_fx_loop', delay);

        this.time.delayedCall(delay, () => {
            this.sound.play('sfx_lightup_big');

            row.sliderWinFrame.setAlpha(1);
            row.winCounterFxLoop.setAlpha(1);
            
            amount.setStyle(this.fonts.amount2);

            this.customHelper.applyDynamicFontSize(amount, 200);
            
            this.request.addAmountWon(amountWon);
        });
        
        row.winCounterFx.once(Phaser.Animations.Events.ANIMATION_START, () => {
            row.winCounterFx.setAlpha(1);
        });

        row.winCounterFx.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
            row.winCounterFx.setAlpha(0);
        });

        this.tweens.add({
            targets: amount,
            scale: 1.3,
            ease: 'Power0',
            yoyo: 1,
            duration: 150,
            delay: delay,
            onComplete: () => {
                if(this.request.scenario['items'][rowIndex]['multiplier'] > 1) {
                    this.flyParticleTo(
                        this.multiplier.x, 
                        this.multiplier.y, 
                        middleOfAmount,  
                        amount.y,
                        0, 
                        () => {
                            row.winCounterFx.setAlpha(1);
                            row.winCounterFx.stop();
                            row.winCounterFx.playAfterDelay('win_counter_fx', 0);

                            let amountText = General.format_currency(this.request.scenario['items'][rowIndex]['amount']);

                            amount.setText(amountText);
                            let amountSend = this.request.scenario['items'][rowIndex]['amount'] - this.request.scenario['items'][rowIndex]['amount_before'];

                            this.request.addAmountWon(amountSend);
                            
                            row.winCounterFx.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                                row.winCounterFx.setAlpha(0);
                            });

                            amount.setStyle(this.fonts.amount3);

                            this.customHelper.applyDynamicFontSize(amount, 200);
                    
                            this.tweens.add({
                                targets: amount,
                                scale: 1.3,
                                ease: 'Power0',
                                yoyo: 1,
                                duration: 150,
                                delay: 0,
                                onComplete: () => {
                                    if(callback) {
                                        callback();
                                    } else {
                                        this.markOpenedSymbol();
                                    }
                                }
                            });
                        }
                    );
                } else {
                    if(callback) {
                        callback();
                    } else {
                        this.markOpenedSymbol();
                    }
                }
            }
        });
    }

    markOpenedSymbol() {
        this.rowsOpened++;

        if (this.rowsOpened === 6) {
            this.checkForContinueGame();
        } else {
            this.countinueMainGame();
        }
    }

    checkForContinueGame() {
        if(this.rowsOpened === 6) {
            store.commit('hideOpenAllButton');
            if(!this.scrollsFound && !this.urnsWillOpenCount) {
                this.finishGame();
            } else {
                this.continueToBonuses();
            }
        }
    }

    showRegularWin() {
        this.regularWinContainer = this.add.container();
        this.regularWinContainer.setScale(0);

        let shape = new Phaser.Geom.Circle(0, 0, 300);
        this.orangeRays = this.add.sprite(0, 0, 'orange_rays').setOrigin(0.5);
        this.regularWinContainer.add(this.orangeRays);
        this.crownRays = this.add.sprite(0, 0, 'crown_rays').setOrigin(0.5);
        this.regularWinContainer.add(this.crownRays);
        this.whiteRays = this.add.sprite(0, 0, 'white_rays').setOrigin(0.5);
        this.regularWinContainer.add(this.whiteRays);
        this.whiteRays2 = this.add.sprite(0, 0, 'white_rays').setOrigin(0.5).setScale(0.7);
        this.regularWinContainer.add(this.whiteRays2);
    
        this.regularWinContainerParticles = this.add.particles('dust_particles');
    
        let emitter = this.regularWinContainerParticles.createEmitter({
            frame:  { frames: [0, 1, 2], cycle: true },
            x: 0, y: 0,
            lifespan: 500,
            quantity: 3,
            scale: 1,
            alpha: { start: 1, end: 0 },
            blendMode: 'ADD',
            emitZone: { type: 'random', source: shape },
            on: false
        });

        this.regularWinAmountContainer = this.customHelper.createWinningFromSprites(General.format_currency(this.request.scenario.total_prize).replace(Config.currency.symbol, ''), 1, '', -50);
        this.regularWinAmountContainer.setScale(0);
        this.regularWinPositioner();
        
        this.sound.play('sfx-win');

        this.tweens.add({
            targets: this.fullFader,
            alpha: 0.8,
            ease: 'Power0',
            duration: 500,
            onComplete: () => {
                this.tweens.add({
                    targets: this.regularWinAmountContainer,
                    scale: 1,
                    ease: Phaser.Math.Easing.Back.Out,
                    duration: 500,
                });
        
                this.tweens.add({
                    targets: this.regularWinContainer,
                    scale: 1,
                    ease: 'Power0',
                    duration: 400,
                    delay: 100,
                    onComplete: () => {
                        emitter.start();
        
                        this.tweens.add({
                            targets: this.crownRays,
                            angle: 360,
                            ease: 'Power0',
                            duration: 12000,
                            repeat:-1
                        });
        
                        this.tweens.add({
                            targets: this.whiteRays,
                            angle: 360,
                            ease: 'Power0',
                            duration: 6000,
                            repeat:-1
                        });
        
                        this.tweens.add({
                            targets: this.whiteRays2,
                            angle: 360,
                            ease: 'Power0',
                            duration: 3000,
                            repeat:-1
                        });
                    }
                });
        
                this.time.delayedCall(2000, () => {  
                    this.tweens.add({
                        targets: this.regularWinAmountContainer,
                        scale: 0,
                        ease: Phaser.Math.Easing.Back.In,
                        duration: 500,
                    });
                    
                    this.tweens.add({
                        targets: this.regularWinContainer,
                        scale: 0,
                        ease: 'Power0',
                        duration: 400,
                        delay: 100,
                        onComplete: () => {
                            emitter.stop();

                            this.fadeInMainFader();
                            
                            this.tweens.add({
                                targets: this.fullFader,
                                alpha: 0,
                                ease: 'Power0',
                                duration: 500,
                                onComplete: () => { 
                                    this.ticketFinished();
                                    this.regularWinAmountContainer.destroy();
                                    this.regularWinContainerParticles.destroy();
                                }
                            });
                        }
                    });
                }); 
            }
        });
    }

    ticketFinished() {
        this.request.ticketFinished();
    }

    fadeInMainFader() {
        this.children.bringToTop(this.fullFaderMain);
        this.tweens.add({
            targets: this.fullFaderMain,
            alpha: 0.4,
            ease: 'Power0',
            duration: 500
        });

        this.tweens.add({
            targets:  this.mainSound,
            volume:   0.5,
            duration: 500
        });
    }

    showBigWin() {
        this.bigWinContainer = this.add.container();

        this.sound.play('stg_bigwin');

        this.tweens.add({
            targets: this.fullFader,
            alpha: 0.8,
            ease: 'Power0',
            duration: 500,
            onComplete: () => {
                this.bigWinDustParticles = this.add.particles('dust_big_win');
                this.bigWinContainer.add(this.bigWinDustParticles);
                this.bigWinFlyingSymbolsParticles = this.add.particles('flying_symbols');
                this.bigWinContainer.add(this.bigWinFlyingSymbolsParticles);

                this.raysBase = this.add.sprite(0, this.cameras.main.centerY, 'rays_base').setOrigin(0.5, 1).setScale(0.2, 1);
                this.bigWinContainer.add(this.raysBase);
                this.raysThick = this.add.sprite(0, this.cameras.main.centerY, 'rays_thick').setOrigin(0.5, 1).setScale(0.2, 1);
                this.bigWinContainer.add(this.raysThick);
                this.raysThin = this.add.sprite(0, this.cameras.main.centerY, 'rays_thin').setOrigin(0.5, 1).setScale(0.2, 1);
                this.bigWinContainer.add(this.raysThin);
                this.bigWinCoinsParticles = this.add.particles('coin_loop');
                this.bigWinContainer.add(this.bigWinCoinsParticles);

                this.bigWinWinLightFlash = this.add.sprite(0, this.cameras.main.centerY, 'win_light_flash').setOrigin(0.5, 0.5).setAlpha(0);
                this.bigWinContainer.add(this.bigWinWinLightFlash);
                
                config = {
                    key: 'win_light_flash',
                    skipMissedFrames: true,
                    frames: this.anims.generateFrameNames('win_light_flash',
                    {
                        prefix: 'Win_Light_Flash_',
                        start: 0,
                        end: 13,
                        suffix: '.png',
                        zeroPad: 4
                    }),
                    frameRate: 30,
                };
        
                this.anims.create(config);

                this.bigWin = this.add.sprite(0, this.cameras.main.centerY, 'big_win_txt').setOrigin(0.5, 0.5).setScale(0.2);
                this.bigWinContainer.add(this.bigWin);
                
                this.raysBase.tween = this.tweens.add({
                    targets: [this.raysBase, this.raysThick, this.raysThin],
                    scaleX: 1,
                    ease: Phaser.Math.Easing.Back.Out,
                    duration: 300,
                });

                let config = {
                    frame:  { frames: [...Array(2).keys()], cycle: true },
                    x: 0,
                    y: 0,
                    alpha: {from: 1, to: 0, ease: 'Expo.easeIn'},
                    speed: { min: 0, max: 2000 },
                    angle: { min: 240, max: 300  },
                    scale: { min: 0.3, max: 1 },
                    lifespan: { min: 1000, max: 2000 },
                    rotate: { start: 0, end: 720},
                    blendMode: 'SCREEN',
                    quantity: 2,
                    on: false
                };

                let config2 = {
                    frame:  { frames: [...Array(2).keys()], cycle: true },
                    x: 0,
                    y: 0,
                    alpha: { start: 1, end: 0, ease: 'Expo.easeIn' },
                    speedX: { min: -300, max: 300 },
                    angle: { min: 240, max: 300 },
                    accelerationY: -1000,
                    gravityY: 100,
                    scale: { min: 0.2, max: 1 },
                    lifespan: { min: 1000, max: 2000 },
                    blendMode: 'SCREEN',
                    quantity: 2,
                    on: false
                };
            
                let emitter = this.bigWinCoinsParticles.createEmitter(config);

                config2.frame = { frames: [...Array(8).keys()], cycle: true };
                config2.frequency = 100;

                let emitter2 = this.bigWinFlyingSymbolsParticles.createEmitter(config2);

                config.frame =  { frames: [...Array(2).keys()], cycle: true };

                let emitter3 = this.bigWinDustParticles.createEmitter(config2);

                this.bigWinPositioner();

                this.bigWin.tween = this.tweens.add({
                    targets: this.bigWin,
                    y: -(this.bigWin.displayHeight),
                    scale: 1,
                    ease: 'Power0',
                    duration: 300,
                    onComplete: () => {
                        emitter.start();
                        emitter2.start();
                        emitter3.start();

                        this.bigWinWinLightFlash
                            .setX(this.bigWin.x)
                            .setY(this.bigWin.y)
                            .setAlpha(1)
                            .play('win_light_flash');
                            
                            this.bigWinWinLightFlash.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                                this.bigWinWinLightFlash.setAlpha(0);
                            });
                        this.bigWin.tween = this.tweens.add({
                            targets: this.bigWin,
                            scale: 1.2,
                            ease: 'Power0',
                            duration: 200,
                            yoyo: true,
                            onComplete: () => {
                                this.bigWinAmountContainer = this.customHelper.createWinningFromSprites(0.00, 1, '', -50)
                                    .setX(this.bigWinContainer.x + this.bigWin.x)
                                    .setY(this.bigWinContainer.y + this.bigWin.y + this.bigWin.displayHeight / 2 + 30);

                                this.bigWinAmountContainer
                                    .setScale(0.5);
                                    
                                const callback = () => {
                                    this.raysBase.tween = this.tweens.add({
                                        targets: [this.raysBase, this.raysThick, this.raysThin],
                                        scaleX: 1.3,
                                        ease: 'Power0',
                                        duration: 300,
                                        delay: 2000,
                                        onComplete: () => {
                                            let duration = 500;

                                            let yOffset = this.cameras.main.height / 2 + this.bigWin.displayHeight + this.bigWin.displayHeight / 2 + 50;

                                            this.bigWin.tween = this.tweens.add({
                                                targets: [this.bigWin, this.bigWinAmountContainer],
                                                y: (target) => {
                                                    return target.y - yOffset;
                                                },
                                                ease: Phaser.Math.Easing.Back.In,
                                                duration
                                            });

                                            this.fadeInMainFader();

                                            this.tweens.add({
                                                targets: this.fullFader,
                                                alpha: 0,
                                                ease: 'Power0',
                                                duration: 500
                                            });

                                            this.bigWin.tween = this.tweens.add({
                                                targets: [this.raysBase, this.raysThick, this.raysThin],
                                                scaleX: 0,
                                                ease: 'Power0',
                                                duration,
                                                onComplete: () => {
                                                    this.bigWinContainer.destroy();
                                                    this.bigWinAmountContainer.destroy();
                                                    this.ticketFinished();
                                                }
                                            });

                                            emitter.stop();
                                            emitter2.stop();
                                            emitter3.stop();
                                        }
                                    });
                                }

                                this.incrementTo(this.request.scenario.total_prize, callback);
                            }
                        });
                    }
                });
            }
        });
    }

    
    incrementTo(winning, callback) {
        let lastAmount = 0;
        let delay = 0;
        let scaleStep = 0;
        let scale = this.bigWinAmountContainer.scaleX;

        if(lastAmount === winning) {
            this.setAmountText(delay, winning, true, 1, callback) 
        } else {
            if(!this.pointCountSound.isPlaying) {
                this.pointCountSound.play();
            }

            var incrementSize = winning / 45;
    
            if(incrementSize < 0.01) {
                incrementSize = 0.01;
            }
            
            if(parseFloat(incrementSize) > 1) {
                incrementSize = Math.ceil(incrementSize);
            }

            scaleStep = 0.5 / (winning / incrementSize);

            while(lastAmount !== winning) {
                lastAmount += incrementSize;
    
                if(lastAmount > winning) {
                    lastAmount = winning;
                }

                scale += scaleStep;

                if(scale > 1) {
                    scale = 1;
                }

                this.setAmountText(delay, lastAmount, lastAmount === winning, scale, callback) 
    
                delay += 55;
            }
        }
    }

    setAmountText(delay, amount, last, scale, callback) {
        amount = General.format_currency(amount).replace(Config.currency.symbol, '');

        this.time.delayedCall(delay, () => {
            
            this.bigWinAmountContainer.destroy();
            
            this.bigWinAmountContainer = this.customHelper.createWinningFromSprites(amount, 1, '', -50)
                .setX(this.bigWinContainer.x + this.bigWin.x)
                .setY(this.bigWinContainer.y + this.bigWin.y + this.bigWin.displayHeight / 2 + 30)
                .setScale(scale);

            if(last) {
                this.pointCountSound.stop();
                this.sound.play('sfx-last-point');

                this.bigWinWinLightFlash
                    .setX(this.bigWinAmountContainer.x - this.bigWinContainer.x)
                    .setY(this.bigWinAmountContainer.y - this.bigWinContainer.y)
                    .setAlpha(1)
                    .play('win_light_flash');

                this.tweens.add({
                    targets: this.bigWinAmountContainer,
                    scale: 1.2,
                    ease: 'Power0',
                    duration: 200,
                    yoyo: true,
                    onComplete: () => {
                        if(callback) {
                            callback();
                        }
                    }
                });
            }
        }, this);
    }

    continueToBonuses() {
        this.children.bringToTop(this.fullFader);

        if(this.scrollsFound) {
            this.bonusOneDepthsWorker(1);
        } 

        this.tweens.add({
            targets: this.fullFader,
            alpha: 0.8,
            ease: 'Power0',
            duration: 700,
            onComplete: () => {
                if(this.scrollsFound) {
                    this.showBonusOne(0);
                } else {
                    this.showBonusTwo();
                }
            }
        });
    }

    showBonusOne(itemIndex) {
        const rowIndex = this.request.scenario['bonus_1'][itemIndex]['index'];
        const symbolIndex = this.request.scenario['bonus_1'][itemIndex]['symbol_index'];
        const symbolName = this.request.scenario['bonus_1'][itemIndex]['symbol'];

        const symbolItems = this.itemsRows[rowIndex].symbols[symbolIndex];
        const symbol = symbolItems.symbol;
        const mult = this.scrollsFound - itemIndex - 1;

        this.runMultiplier();

        this.explodeWinCounterFx(this.scrollIndicator);

        this.scrollMultiplier.setText(`x${mult}`);

        if(mult === 0) {
            this.scrollIndicator.stop();
            this.scrollMultiplier.setAlpha(0);
            this.scrollIndicator.setTexture('scroll_indicator_inactive');
        }
        
        this.flyParticleTo(
            this.scrollIndicator.x,  
            this.scrollIndicator.y,
            symbol.x, 
            symbol.y, 
            0, 
            () => {
                symbol.setAlpha(0);
                symbolItems.symbolsShuffle.setAlpha(1);
                symbolItems.symbolsShuffle.setDepth(1);

                symbolItems.symbolsShuffle.play('symbols_shuffle');

                this.time.delayedCall(700, () => {
                    this.sound.play('sfx_value_spin_bonus');
                });

                symbolItems.symbolsShuffle.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                    symbol.setTexture(`symbol_${symbolName}`);
                    symbolItems.winCounterFx.setAlpha(1);
                    symbolItems.winCounterFx.playAfterDelay('win_counter_fx', 0);
                    symbolItems.symbolsShuffle.setAlpha(0);
                    symbolItems.symbolsShuffle.setDepth(0);
                    symbol.setAlpha(1);
                    symbol.playAfterDelay(`symbol_${symbolName}`, 0);

                    this.bonus1Opened[rowIndex]++;
                    
                    symbolItems.winCounterFx.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                        symbolItems.winCounterFx.setAlpha(0);

                        let callback = () => {
                            if(mult > 0) {
                                this.showBonusOne(itemIndex + 1);
                            } else {
                                this.tweens.add({
                                    targets: this.fullFader,
                                    alpha: 0,
                                    ease: 'Power0',
                                    duration: 700,
                                    onComplete: () => {
                                        this.bonusOneDepthsWorker(0);
                                        this.scrollsFound = 0;
                                        this.checkForContinueGame();
                                    }
                                });
                            }
                        }
                        
                        let lineFinished = Object.entries(this.bonus1Mapped[rowIndex]).length === this.bonus1Opened[rowIndex];
                        
                        if(lineFinished) {
                            this.stopToMultiplier(this.request.scenario['items'][rowIndex].multiplier, true);
                        }

                        if(lineFinished && this.request.scenario['items'][rowIndex]['lucky'] && this.request.scenario['items'][rowIndex]['changeable']) {
                            this.markLuckySymbols(this.itemsRows[rowIndex], rowIndex, callback, this.request.scenario['items'][rowIndex]['amount_before']);
                        } else {
                            callback();
                        }
                    });
                });
            }
        );
    }

    bonusOneDepthsWorker(depth) {
        this.multiplierFrame.setDepth(depth);
        this.multiplier.setDepth(depth);
        this.scrollIndicator.setDepth(depth);
        this.scrollMultiplier.setDepth(depth);

        for(let i = 0; i < 6; i++) {
            this.itemsRows[i].amount.setDepth(depth);
            this.itemsRows[i].winCounterFxLoop.setDepth(depth);
            this.itemsRows[i].winCounterFx.setDepth(depth);
            
            for(let j = 0; j < 3; j++) {
                let symbol = this.request.scenario['items'][i]['symbols'][j];

                if(!['urn', 'scroll'].includes(symbol) &&
                    (!this.request.scenario['items'][i].lucky 
                        || (this.request.scenario['items'][i].lucky && this.request.scenario['items'][i].changeable))) {
                    this.itemsRows[i].symbols[j].symbol.setDepth(depth);
                    this.itemsRows[i].symbols[j].winFxLoop.setDepth(depth);
                    this.itemsRows[i].symbols[j].winCounterFx.setDepth(depth);
                }
            }
        }
    }

    finishGame() {
        this.tweens.add({
            targets: this.multiplier,
            alpha: 0,
            ease: 'Power0',
            duration: 500,
        });

        this.tweens.add({
            targets:  this.mainSound,
            volume:  0.5,
            duration: 500
        });

        if(this.request.scenario.total_prize > 0) {
            const ratio = this.request.scenario.total_prize / this.request.ticketAmount;

            if(ratio >= Config.assets.ratios.big_win) {
                this.showBigWin();
            } else {
                this.showRegularWin();
            }
        } else {
            this.fadeInMainFader();
            this.ticketFinished();
        }
    }

    scrollHits(multiplier, last) {
        if(!this.scrollIndicator.anims.isPlaying) {
            this.scrollIndicator.play('scroll_indicator_active_loop');
        }

        this.explodeWinCounterFx(this.scrollIndicator);

        this.scrollMultiplier.setText(`x${multiplier}`);
        this.scrollMultiplier.setAlpha(1);
        
        this.tweens.add({
            targets: this.scrollMultiplier,
            scale: 1.3,
            ease: 'Power0',
            duration: 100,
            onComplete: () => {
                if(last) {
                    this.tweens.add({
                        targets: this.scrollMultiplier,
                        scale: 1,
                        ease: 'Power0',
                        duration: 100,
                        onComplete: () => {
                            if(last) {
                                this.scrollMultiplier.setScale(1);
                                this.markOpenedSymbol();
                            }
                        }
                    });
                }
            }
        });
    }
    
    explodeWinCounterFx(onElement) {
        this.winCounterFx.setDepth(9);
        this.winCounterFx.x = onElement.x;
        this.winCounterFx.y = onElement.y;
        this.winCounterFx.setAlpha(1);
        this.winCounterFx.play('win_counter_fx');
    }

    urnHits(multiplier, last) {
        if(!this.urnFrameActive.anims.isPlaying) {
            this.urnFrameActive.setAlpha(1);
            this.urnFrameActive.play('urn_indicator_active_loop');
        }

        this.explodeWinCounterFx(this.urnFrameActive);

        this.urnMultiplier.setText(`x${multiplier}`);
        this.urnMultiplier.setAlpha(1);

        this.tweens.add({
            targets: this.urnMultiplier,
            scale: 1.3,
            ease: 'Power0',
            duration: 100,
            onComplete: () => {
                if(last) {
                    this.tweens.add({
                        targets: this.urnMultiplier,
                        scale: 1,
                        ease: 'Power0',
                        duration: 100,
                        onComplete: () => {
                            if(last) {
                                this.urnMultiplier.setScale(1);
                                this.markOpenedSymbol();
                            }
                        }
                    });
                }
            }
        });
    }

    flyParticleTo(startX, startY, destinationX, destinationY, delay, callback, callbackParams) {
        this.time.delayedCall(delay, () => {
            const randomSfx = Phaser.Math.RND.integerInRange(1, 3);
            this.sound.play(`sfx-value-travel-${randomSfx}`);

            let path = new Phaser.Curves.Path(startX, startY);
            let x2 = destinationX;
            let y2 = destinationY > startY ? destinationY - startY : startY - destinationY;
    
            let x3 = destinationX;
            let y3 = destinationY;
    
            path.cubicBezierTo(destinationX, destinationY, x2, y2, x3, y3);

            let distance = Phaser.Math.Distance.Between(startX, startY, destinationX, destinationY) / 4;

            let scaler = 0.7;
            let delayOffset = 0;
            let itemsCount = 20;
            let delayOffsetStep = 0.008 * distance;
            let delayStaticOffset = 0.030 * distance;

            for (var i = 0; i < itemsCount; i++)
            {
                this.addFollower(path, distance, scaler, delayOffset, delayStaticOffset, i, callback, callbackParams);

                delayOffset += delayOffsetStep

                scaler -= (0.7 / 20);
            }
        }, {}, this);
    }
    
    drawLine(startX, startY, destinationX, destinationY) {
        let path = new Phaser.Curves.Path(startX, startY);//destinationX, destinationY, destinationX / 3, destinationY + 250, destinationX, destinationY + 500
        let x2 = destinationX;
        let y2 = destinationY > startY ? destinationY - startY : startY - destinationY;

        let x3 = destinationX;
        let y3 = destinationY;

        path.cubicBezierTo(destinationX, destinationY, x2, y2, x3, y3);

        let graphics = this.add.graphics();
        graphics.lineStyle(2, 0xffffff, 1);

        path.draw(graphics);

    }

    addFollower(path, distance, scaler, delayOffset, delayStaticOffset, i, callback, callbackParams) {
        var follower = this.add.follower(path, 100, 100 + (30 * i), 'flares', 'blue');
        follower.setDepth(10);
        follower.setBlendMode(Phaser.BlendModes.ADD);
        follower.setScale(scaler);

        follower.startFollow({
            duration:distance * 2,
            positionOnPath: true,
            ease: 'Linear',
            delay: i * delayStaticOffset - delayOffset,
            onComplete: () => {
                follower.destroy();

                if(i === 0) {
                    if(callback) {
                        callback(callbackParams);
                    }
                }
            }
        });
    }

    stopToMultiplier(multiplier, ignoreStopFx) {
        this.multiplier.setText(`x${multiplier}`);
        this.multiplier.alpha = 1;
        
        this.tweens.add({
            targets: this.multiplier,
            scale: 1.3,
            ease: 'Power0',
            yoyo: 1,
            duration: 150
        });

        if(!ignoreStopFx) {
            this.multiplierStopFx.play('multiplier_stop_fx');

            const randomSfx = Phaser.Math.RND.integerInRange(1, 3);

            this.sound.play(`sfx-beam-${randomSfx}`);
        }

        this.multiplierFrame.stop();
        this.multiplierSpinSound.stop();
        this.multiplierFrame.play('multiplier_stop_frame');
    }

    runMultiplier() {
        this.multiplier.setAlpha(0);
        this.multiplierFrame.play('multiplier_shuffle_loop');
        this.multiplierSpinSound.play();
    }

    afterComplete() {
    }

    createBg() {
        this.bg = this.add.sprite(0, 0, 'bg').setOrigin(0.5, 0);
        this.positionerContainer.add(this.bg);
        this.curtainsLeft = this.add.sprite(0, 0, 'curtains_left').setOrigin(0, 0);
        this.curtainsRight = this.add.sprite(0, 0, 'curtains_right').setOrigin(1, 0);
        this.curtainsLeftPortrait = this.add.sprite(0, 0, 'curtains_left_portrait').setOrigin(0, 0);
        this.curtainsRightPortrait = this.add.sprite(0, 0, 'curtains_right_portrait').setOrigin(1, 0);
        this.addCurtainsAnimations();

        this.logo = this.add.sprite(0, 0, 'logo').setOrigin(0.5, 0);
        this.frame = this.add.sprite(0, 0, 'symbols_frame').setOrigin(0.5, 0);

        this.multiplierStopFx = this.add.sprite(0, 0, 'multiplier_stop_fx').setOrigin(1, 0.5);

        let config = {
            key: 'multiplier_stop_fx',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('multiplier_stop_fx', {
                start: 0,
                end: 19,
            }),
            frameRate: 25
        };

        this.anims.create(config);
        this.multiplierStopFx.anims.load(config);

        this.multiplierFrame = this.add.sprite(0, 0, 'multiplier_frame').setOrigin(0.5, 0.5);
        this.createMultiplierFrameAnims();

        this.multiplier = this.add.text(0, 0, 'x1', this.fonts.multiplier).setOrigin(0.5, 0.5);

        this.multiplier.setAlpha(0);

        this.scrollIndicator = this.add.sprite(0, 0, 'scroll_indicator_inactive').setOrigin(0.5, 0.5);
        this.scrollIndicator.originalWidth = this.scrollIndicator.width;
        this.scrollIndicator.originalHeight = this.scrollIndicator.height;
        
        this.scrollMultiplier = this.add.text(0, 0, 'x0', this.fonts.miniMultiplier).setOrigin(0.5, 0.5);

        this.scrollMultiplier.setAlpha(0);

        this.urnFrame = this.add.sprite(0, 0, 'urn_indicator_inactive').setOrigin(0.5, 0.5);
        this.urnFrame.originalWidth = this.urnFrame.width;
        this.urnFrame.originalHeight = this.urnFrame.height;

        this.urnFrameActive = this.add.sprite(0, 0, 'urn_indicator_active_loop').setOrigin(0.5, 0.5);
        this.urnFrameActive.setAlpha(0);

        this.urnMultiplier = this.add.text(0, 0, 'x0', this.fonts.miniMultiplier).setOrigin(0.5, 0.5);

        this.urnMultiplier.setAlpha(0);
        
        config = {
            key: 'urn_indicator_active_loop',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('urn_indicator_active_loop', {
                start: 0,
                end: 28,
            }),
            frameRate: 30,
            repeat: -1
        };

        this.anims.create(config);

        config = {
            key: 'scroll_indicator_active_loop',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('scroll_indicator_active_loop', {
                start: 0,
                end: 28,
            }),
            frameRate: 30,
            repeat: -1
        };

        this.anims.create(config);
        
        this.winCounterFx = this.add.sprite(0, 0, 'win_counter_fx').setOrigin(0.5, 0.5);

        config = {
            key: 'win_counter_fx',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('win_counter_fx',
            {
                prefix: 'Win_Counter_FX_',
                start: 0,
                end: 25,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 30,
        };

        this.anims.create(config);

        this.winCounterFx.setAlpha(0);
    }

    createMultiplierFrameAnims() {
        let config = {
            key: 'multiplier_shuffle_loop',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('multiplier_shuffle_loop', {
                start: 0,
                end: 25,
            }),
            frameRate: 25,
            repeat: -1
        };

        this.anims.create(config);
        this.multiplierFrame.anims.load(config);

        config = {
            key: 'multiplier_stop_frame',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('multiplier_stop_frame',
            {
                prefix: 'Multiplier_Stop_Frame_',
                start: 3,
                end: 28,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
        };

        this.anims.create(config);
        this.multiplierFrame.anims.load(config);
    }

    createGameItems() {
        this.firstColumnContainer = this.add.rexContainerLite();
        this.secondColumnContainer = this.add.rexContainerLite();
        this.itemsRows = [];

        let config = {
            key: 'slider_hover',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('slider_hover', {
                start: 0,
                end: 14,
            }),
            frameRate: 30,
            repeat: -1
        };

        this.anims.create(config);

        config = {
            key: 'scarab_hover',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('scarab_hover', {
                start: 0,
                end: 14,
            }),
            frameRate: 30,
            repeat: -1
        };

        this.anims.create(config);

    
        let scarabAppearConfig = {
            key: 'scarab_appear',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('scarab_appear', {
                start: 0,
                end: 14,
            }),
            frameRate: 60
        };

        this.anims.create(scarabAppearConfig);
        
        config = {
            key: 'scarab_smash',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('scarab_smash', {
                start: 0,
                end: 14,
            }),
            frameRate: 25
        };

        this.anims.create(config);

        config = {
            key: 'symbols_shuffle',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('symbols_shuffle', {
                start: 0,
                end: 26,
            }),
            frameRate: 30
        };

        this.anims.create(config);

        config = {
            key: 'win_fx_loop',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('win_fx_loop',
            {
                prefix: 'Symbol_Win_FX_LOOP_',
                start: 0,
                end: 28,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 30,
            repeat: -1
        };

        this.anims.create(config);

        config = {
            key: 'win_counter_fx_loop',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('win_counter_fx_loop',
            {
                prefix: 'Win_Counter_FX_Loop_',
                start: 0,
                end: 28,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 30,
            repeat: -1
        };

        this.anims.create(config);

        for(let i = 0; i < 6; i++) {
            let firstColumn = i < 3;
            let actualColumnContainer = this.firstColumnContainer;

            if(!firstColumn) {
                actualColumnContainer = this.secondColumnContainer;
            }

            this.itemsRows[i] = {};

            this.itemsRows[i].columnIndex = firstColumn ? 1 : 2;

            this.itemsRows[i].slider = this.add.sprite(0, 0, 'slider').setOrigin((firstColumn ? 1 : 0 ), 0.5);    
            actualColumnContainer.add(this.itemsRows[i].slider);

            this.itemsRows[i].sliderWinFrame = this.add.sprite(0, 0, 'winline').setOrigin((firstColumn ? 1 : 0 ), 0.5);    
            actualColumnContainer.add(this.itemsRows[i].sliderWinFrame);
            this.itemsRows[i].sliderWinFrame.setAlpha(0);

            this.itemsRows[i].sliderHover = this.add.sprite(0, 0, 'slider_hover').setOrigin((firstColumn ? 1 : 0 ), 0.5);    
            this.itemsRows[i].sliderHover.setAlpha(0);
            actualColumnContainer.add(this.itemsRows[i].sliderHover);

            this.itemsRows[i].slider.maskShape = this.add.graphics().fillRect(
                0,
                0,
                this.itemsRows[i].slider.displayWidth,
                this.itemsRows[i].slider.displayHeight
            );

            let mask = this.itemsRows[i].slider.maskShape.createGeometryMask();
            this.itemsRows[i].slider.setMask(mask);

            this.itemsRows[i].winCounterFxLoop = this.add.sprite(0, 0, 'win_counter_fx_loop').setOrigin(0.5);
            this.itemsRows[i].winCounterFxLoop.setAlpha(0);
            this.itemsRows[i].winCounterFx = this.add.sprite(0, 0, 'win_counter_fx').setOrigin(0.5);
            this.itemsRows[i].winCounterFx.setAlpha(0);

            this.itemsRows[i].amount = this.add.text(0, 0, General.format_currency(0), this.fonts.amount).setOrigin(firstColumn ? 1 : 0, 0.5);

            this.customHelper.applyDynamicFontSize(this.itemsRows[i].amount, 200);

            this.addAmountGradient(this.itemsRows[i].amount);

            this.itemsRows[i].amount.setAlpha(0);

            actualColumnContainer.add(this.itemsRows[i].winCounterFxLoop);
            actualColumnContainer.add(this.itemsRows[i].amount);
            this.children.bringToTop(this.itemsRows[i].slider)
            this.children.bringToTop(this.itemsRows[i].sliderWinFrame);
            this.children.bringToTop(this.itemsRows[i].sliderHover);
            actualColumnContainer.add(this.itemsRows[i].winCounterFx);

            this.itemsRows[i].symbols = [];

            for(let j = 0; j < 3; j++) {
                this.itemsRows[i].symbols[j] = {};
                this.itemsRows[i].symbols[j].winFxLoop = this.add.sprite(0, 0, 'win_fx_loop').setOrigin(0.5, 0.5);
                this.itemsRows[i].symbols[j].winFxLoop.setAlpha(0);
                
                this.itemsRows[i].symbols[j].symbolsShuffle = this.add.sprite(0, 0, 'symbols_shuffle').setOrigin(0.5, 0.5);
                this.itemsRows[i].symbols[j].symbolsShuffle.setAlpha(0);

                this.itemsRows[i].symbols[j].symbol = this.add.sprite(0, 0).setOrigin(0.5, 0.5);

                this.itemsRows[i].symbols[j].winCounterFx = this.add.sprite(0, 0, 'win_counter_fx').setOrigin(0.5, 0.5);
                this.itemsRows[i].symbols[j].winCounterFx.setAlpha(0);

                this.itemsRows[i].symbols[j].scarabAppear = this.add.sprite(0, 0, 'scarab_appear').setOrigin(0.5, 0.5);
                this.itemsRows[i].symbols[j].scarabAppear.originalWidth = this.itemsRows[i].symbols[j].scarabAppear.width;
                this.itemsRows[i].symbols[j].scarabAppear.originalHeight = this.itemsRows[i].symbols[j].scarabAppear.height;
                this.itemsRows[i].symbols[j].scarabHover = this.add.sprite(0, 0, 'scarab_hover').setOrigin(0.5, 0.5);

                this.itemsRows[i].symbols[j].scarabAppear.anims.load('scarab_appear');
                this.itemsRows[i].symbols[j].scarabAppear.setFrame(14);
                this.itemsRows[i].symbols[j].scarabHover.setAlpha(0);

                actualColumnContainer.add(this.itemsRows[i].symbols[j].symbol);
                actualColumnContainer.add(this.itemsRows[i].symbols[j].symbolsShuffle);
                actualColumnContainer.add(this.itemsRows[i].symbols[j].winFxLoop);
                actualColumnContainer.add(this.itemsRows[i].symbols[j].winCounterFx);
                actualColumnContainer.add(this.itemsRows[i].symbols[j].scarabAppear);
                actualColumnContainer.add(this.itemsRows[i].symbols[j].scarabHover);
            }

            for (let symbol of Config.symbols) {
                this.addSymbolAnimation(symbol);
            }

            this.addSymbolAnimation('urn');
            this.addSymbolAnimation('scroll');
        }
    }

    addSymbolAnimation(symbol) {
        let config = {
            key: `symbol_${symbol}`,
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers(`symbol_${symbol}`, {
                start: 0,
                end: 14,
            }),
            frameRate: 25
        };

        this.anims.create(config);

        config = {
            key: `symbol_${symbol}_win`,
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers(`symbol_${symbol}_win`, {
                start: 0,
                end: 14,
            }),
            frameRate: 25
        };

        this.anims.create(config);
    }

    addAmountGradient (text) {
    	let grd = text.context.createLinearGradient(0, 0, 0, text.height);
        
        grd.addColorStop(0, '#f2d226');
        grd.addColorStop(.8, '#bf7e1c');
        grd.addColorStop(1, '#b8711a');

	    text.setFill(grd);
    }

    addCurtainsAnimations() {
        let config = this.anims.create({
            key: 'curtains_left',
            frames: this.anims.generateFrameNames('curtains_left',
            {
                prefix: 'BG_H_Curtains_Left_',
                start: 0,
                end: 49,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            repeat: -1
        });

        this.curtainsLeft.anims.load(config);

        config = this.anims.create({
            key: 'curtains_right',
            frames: this.anims.generateFrameNames('curtains_right',
            {
                prefix: 'BG_H_Curtains_Right_',
                start: 0,
                end: 49,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            repeat: -1
        });

        this.curtainsRight.anims.load(config);

        config = this.anims.create({
            key: 'curtains_left_portrait',
            frames: this.anims.generateFrameNames('curtains_left_portrait',
            {
                prefix: 'BG_V_Curtains_Left_',
                start: 0,
                end: 49,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            repeat: -1
        });

        this.curtainsLeft.anims.load(config);

        config = this.anims.create({
            key: 'curtains_right_portrait',
            frames: this.anims.generateFrameNames('curtains_right_portrait',
            {
                prefix: 'BG_V_Curtains_Right_',
                start: 0,
                end: 49,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            repeat: -1
        });

        this.curtainsRight.anims.load(config);
    }

    createBonus2() {
        this.bonus2Container = this.add.rexContainerLite();
        this.bonus2Container.changeOrigin(0.5, 1);
        this.bonus2Container.setAlpha(0);

        this.bonus2Rows = {};
        
        this.backLight = this.add.sprite(0, 0, 'back_light').setOrigin(0.5, 0);
        this.backLight.setAlpha(0);
        this.bonus2Show = false;

        for(let i = 0; i <= 3 ; i++) {
            let row = this.add.sprite(0, 0, `step_${i+1}`).setOrigin(0.5, 1);

            this.bonus2Rows[i] = row;
            this.bonus2Container.addLocal(row);

            this.bonus2Rows[i].urns = {};

            for(let j = 0; j <= (3 - i); j++) {
                this.bonus2Rows[i].urns[j] = this.add.sprite(0, 0, 'urn_smash_1').setOrigin(0.5, 1);
                this.bonus2Container.addLocal(this.bonus2Rows[i].urns[j]);
                this.bonus2Rows[i].urns[j].originalWidth = this.bonus2Rows[i].urns[j].width;
                this.bonus2Rows[i].urns[j].originalHeight = this.bonus2Rows[i].urns[j].height;

                this.bonus2Rows[i].urns[j].over = this.add.sprite(0, 0, 'urn_mouseover').setOrigin(0.5, 1);
                this.bonus2Container.addLocal(this.bonus2Rows[i].urns[j].over);
                this.bonus2Container.setChildLocalAlpha(this.bonus2Rows[i].urns[j].over, 0);

                this.bonus2Rows[i].urns[j].amount = this.add.text(0, 0, General.format_currency(0), this.fonts.urnsAmounts).setOrigin(0.5, 0.5);
                this.bonus2Rows[i].urns[j].winCounterFxLoop = this.add.sprite(0, 0, 'win_counter_fx_loop').setOrigin(0.5);

                this.bonus2Container.addLocal(this.bonus2Rows[i].urns[j].amount);
                this.bonus2Container.setChildLocalAlpha(this.bonus2Rows[i].urns[j].amount, 0);

                this.bonus2Container.addLocal(this.bonus2Rows[i].urns[j].winCounterFxLoop);
                this.bonus2Container.setChildLocalAlpha(this.bonus2Rows[i].urns[j].winCounterFxLoop, 0);
            }
        }

        for(let i = 3; i >= 0; i--) {
            for(let j = 0; j <= (3 - i); j++) {
                this.children.bringToTop(this.bonus2Rows[i].urns[j].winCounterFxLoop);
                this.children.bringToTop(this.bonus2Rows[i].urns[j].amount);
                this.children.bringToTop(this.bonus2Rows[i].urns[j]);
                this.children.bringToTop(this.bonus2Rows[i].urns[j].over);
            }

            this.children.bringToTop(this.bonus2Rows[i]);
        }

        this.frontLight = this.add.sprite(0, 0, 'front_light').setOrigin(0.5, 0);
        this.frontLight.setAlpha(0);

        let config;

        for(let i = 0; i < 3; i++) {
            config = {
                key: `urn_smash_${i+1}`,
                skipMissedFrames: true,
                frames: this.anims.generateFrameNumbers(`urn_smash_${i+1}`, {
                    start: 0,
                    end: 17,
                }),
                frameRate: 30
            };
    
            this.anims.create(config);
        }
        
        config = {
            key: `urn_mouseover`,
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers(`urn_mouseover`, {
                start: 0,
                end: 25,
            }),
            repeat: -1,
            frameRate: 30
        };

        this.anims.create(config);

        this.urnFrameActive2 = this.add.sprite(0, 0, 'urn_indicator_active_loop').setOrigin(0.5, 0.5);
        this.urnFrameActive2.setAlpha(0);

        this.urnMultiplier2 = this.add.text(0, 0, 'x0', this.fonts.largeMultiplier).setOrigin(0.5, 0.5);
        this.urnMultiplier2.setAlpha(0);

        this.bonus2WonText = this.add.text(0, 0, Config.lang.bonus_win.toUpperCase(), this.fonts.bonus2WonText).setOrigin(0.5, 0.5);
        this.bonus2WonText.setAlpha(0);

        this.bonus2WonFrame = this.add.sprite(0, 0, 'win_counter_frame').setOrigin(0.5, 0.5);
        this.bonus2WonFrame.setAlpha(0);

        this.bonus2WonAmount = this.add.text(0, 0, General.format_currency(0, true), this.fonts.xlMultiplier).setOrigin(0.5, 0.5);
        this.bonus2WonAmount.setAlpha(0);
    }

    showBonusTwo() {
        let bonusWin = 0;

        for (let [index, pick] of Object.entries(this.request.scenario.bonus_2.picks)) {
            if(pick['lucky']) {
                bonusWin += pick.amount;
            }
        }

        bonusWin = bonusWin / 2;
        
        this.tweens.add({
            targets:  this.mainSound,
            volume:   0,
            duration: 500,
            onComplete: () => {
                this.mainSound.stop();
            }
        });

        this.bonusSound.play();

        this.tweens.add({
            targets:  this.bonusSound,
            volume:   1,
            duration: 500
        });
        
        //determing last max width of counter and changing font size to fit it in frame
        this.bonus2WonAmount.setText(General.format_currency(bonusWin, bonusWin == Math.round(bonusWin)));
        this.bonus2WonAmount.setStyle(this.fonts.xlMultiplier);
        this.customHelper.applyDynamicFontSize(this.bonus2WonAmount, this.bonus2WonFrame.width - 10);
        this.bonus2WonAmount.setText(General.format_currency(0, true));

        this.bonus2Show = true;

        let delay = 0;
        let speed = 200;
        let delayStep = 150;
        let speedStep = 200;

        this.bonus2Picks = 0;
        this.bonus2PicksFinished = 0;
        this.bonus2PicksByAmount = {};

        this.backLight.setDepth(1);
        this.bonus2Container.setDepth(2);
        this.frontLight.setDepth(3);
        this.children.bringToTop(this.urnFrameActive2);
        this.children.bringToTop(this.urnMultiplier2);

        this.bonus2WonText.setDepth(3);
        this.bonus2WonFrame.setDepth(3);
        this.bonus2WonAmount.setDepth(3);

        this.children.bringToTop(this.bonus2WonText);
        this.children.bringToTop(this.bonus2WonFrame);
        this.children.bringToTop(this.bonus2WonAmount);

        this.urnFrameActive2.play('urn_indicator_active_loop');
        this.urnMultiplier2.setText(`x${this.urnsWillOpenCount}`);

        this.backLight.tween = this.tweens.add({
            targets: [this.backLight, this.frontLight, this.urnFrameActive2, this.urnMultiplier2, this.bonus2WonText, this.bonus2WonFrame, this.bonus2WonAmount],
            alpha: 1,
            ease: 'Power0',
            duration: speed * 4 + delayStep * 4,
        });

        for (let [rowIndex, row] of Object.entries(this.bonus2Rows)) {
            this.tweenInBonus2Row(rowIndex, row, speed, delay, speedStep);
            speed += speedStep;

            delay += delayStep;
        }

        this.bonus2Container.setAlpha(1);
    }

    tweenInBonus2Row(rowIndex, row, speed, delay, speedStep) {
        let tweenItems = [];

        tweenItems.push(row);
        
        this.bonus2Container.setChildLocalPosition(row, row.rexContainer.x, row.displayHeight + row.urns[0].displayHeight);

        for (let [urnKey, urn] of Object.entries(row.urns)) {
            tweenItems.push(urn);
            this.bonus2Container.setChildLocalPosition(urn, urn.rexContainer.x, row.rexContainer.y - row.displayHeight);
        }

        this.time.delayedCall(400 * parseInt(rowIndex), () => {
            const index = parseInt(rowIndex)+1;

            this.sound.play(`sfx_bonus_row_${index}`);
        });

        row.tween = this.tweens.add({
            targets: tweenItems,
            y: (target) => {
                return target.originalY - 10;
            },
            ease: 'Power0',
            duration: speed,
            delay,
            onComplete: () => {
                this.tweens.add({
                    targets: tweenItems,
                    y: (target) => {
                        return target.originalY;
                    },
                    ease: 'Power0',
                    duration: speedStep,
                    onComplete: () => {
                        if(rowIndex == 3) {
                            this.enableBonus2Inputs();
                        }
                    }
                });
            }
        });
    }

    tweenOutBonus2() {
        this.bonus2Show = true;

        let delay = 0;
        let speed = 200;
        let delayStep = 50;
        let speedStep = 200;

        this.backLight.tween = this.tweens.add({
            targets: [this.backLight, this.frontLight, this.urnFrameActive2, this.urnMultiplier2, this.bonus2WonText, this.bonus2WonFrame, this.bonus2WonAmount, this.fullFader, this.urnFrameActive, this.urnMultiplier],
            alpha: 0,
            ease: 'Power0',
            duration: speed * 4 + delayStep * 4,
            onComplete: () => {
                this.urnFrameActive2.stop();
                this.urnFrameActive.stop();
            }
        });

        for(let i = 3; i >= 0; i--) {
            let row = this.bonus2Rows[i];

            this.tweenOutBonus2Row(i, row, speed, delay, speedStep);

            speed += speedStep;
        }
    }

    tweenOutBonus2Row(rowIndex, row, speed, delay, speedStep) {
        let tweenItems = [];

        tweenItems.push(row);

        let toY = row.displayHeight + row.urns[0].displayHeight + this.bonus2Container.y;

        for (let [urnKey, urn] of Object.entries(row.urns)) {
            tweenItems.push(urn);
        }

        row.tween = this.tweens.add({
            targets: tweenItems,
            y: (target) => {
                return target.y - 10;
            },
            ease: 'Power0',
            duration: speed / 2,
            delay,
            onComplete: () => {
                this.tweens.add({
                    targets: tweenItems,
                    y: toY,
                    ease: 'Power0',
                    duration: speedStep,
                    onComplete: () => {
                        if(rowIndex == 0) {
                            this.tweens.add({
                                targets:  this.bonusSound,
                                volume:   0,
                                duration: 500,
                                onComplete: () => {
                                    this.bonusSound.stop();
                                }
                            });

                            this.mainSound.play();
                            
                            this.bonus2Container.setAlpha(0);
                            this.finishGame();
                        }
                    }
                });
            }
        });
    }

    enableBonus2Inputs() {
        for (let [rowIndex, row] of Object.entries(this.bonus2Rows)) {
            for (let [urnKey, urn] of Object.entries(row.urns)) {
                urn.setInteractive({ cursor: 'pointer', pixelPerfect: true})
                    .on('pointerup', () => {
                        this.openUrn(urn);
                        urn.over.stop();
                        this.bonus2Container.setChildLocalAlpha(urn.over, 0);
                    })
                    .on('pointerover', () => {
                        this.bonus2Container.setChildLocalAlpha(urn.over, 1);
                        urn.over.play('urn_mouseover');
                        
                        const randomSfx = Phaser.Math.RND.integerInRange(1, 3);
                        this.sound.play(`sfx_bonus_hover_${randomSfx}`);
                    })
                    .on('pointerout', () => {
                        urn.over.stop();
                        this.bonus2Container.setChildLocalAlpha(urn.over, 0);
                    });
            }
        }
    }

    openUrn(urn) {
        let randomAnimIndex = Phaser.Math.Between(1, 3);

        if(urn.opened || this.bonus2Picks === this.request.scenario.bonus_2.picks.length) {
            return;
        }

        this.urnsWillOpenCount--;

        this.urnMultiplier2.setText(`x${this.urnsWillOpenCount}`);

        urn.opened = true;
        this.customHelper.removeClickable(urn);

        const item = this.request.scenario.bonus_2.picks[this.bonus2Picks];

        this.bonus2Picks++;

        const amount = item.amount;
        
        if(!this.bonus2PicksByAmount[amount]) {
            this.bonus2PicksByAmount[amount] = [];
        }

        this.bonus2PicksByAmount[amount].push(urn);
        
        urn.amount.setStyle(this.fonts.urnsAmounts2);
        urn.amount.setText(General.format_currency(amount, Math.round(amount) == amount));
        this.customHelper.applyDynamicFontSize(urn.amount, 180);
        urn.amount.setScale(0);
        this.bonus2Container.setChildLocalAlpha(urn.amount, 1);
        
        this.tweens.add({
            targets: urn.amount,
            scale: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 500,
            onComplete: () => {
                if(this.bonus2PicksByAmount[amount].length > 1) {
                    let delay = 0;

                    for(let i = 0; i < 2; i++) {
                        this.markLuckyBonusUrnAmount(this.bonus2PicksByAmount[amount][0], delay);
                        delay += 500;
                        this.bonus2PicksByAmount[amount].splice(0, 1);
                    }
                    
                    this.time.delayedCall(delay, () => {
                        this.request.addAmountWon(amount);
                        this.incrementBonusAmount(amount);
                    });
                } else {
                    this.bonus2PicksFinished++;
                    
                    if(this.bonus2PicksFinished === this.request.scenario.bonus_2.picks.length) {
                        this.finishBonus2();
                    }
                }
            }
        });

        this.sound.play(`sfx_bonus_reveal_${randomAnimIndex}`);

        urn.play(`urn_smash_${randomAnimIndex}`);
    }

    incrementBonusAmount(winAmount) {
        this.bonusWinAmount += winAmount;
        this.countingAmount++;

        let loadedNow = 0;
        let step = winAmount / 5.999;

        if(step < 0.01) {
            step = 0.01;
        }

        step = parseFloat(step.toFixed(2));

        if(parseFloat(step) > 1) {
            step = Math.ceil(step);
        }

        while(loadedNow != winAmount) {
            if(this.final_amount_won) {
                return;
            }

            this.bonusLoadedAmount += step;
            loadedNow += step;
            
            this.bonusLoadedAmount = parseFloat(this.bonusLoadedAmount.toFixed(2));
            loadedNow = parseFloat(loadedNow.toFixed(2));

            if(loadedNow > winAmount) {
                let diff = loadedNow - winAmount;
                loadedNow = winAmount;

                this.bonusLoadedAmount -= diff;
            }

            this.setAmount(this.bonusLoadedAmount, this.countingDelay, loadedNow === winAmount, this.bonus2PicksFinished === this.request.scenario.bonus_2.picks.length);

            this.countingDelay += this.icrementationDelay;
        }
    }
    
    setAmount(amount, delay, last, lastPick) {
        this.time.delayedCall(delay, () => {
            this.countingDelay -= this.icrementationDelay;

            let ignorePrecision = Math.round(amount) == amount && lastPick && last;

            this.bonus2WonAmount.setText(General.format_currency(amount, ignorePrecision));
            this.bonus2WonAmount.setStyle(this.fonts.xlMultiplier);
            this.customHelper.applyDynamicFontSize(this.bonus2WonAmount, this.bonus2WonFrame.width - 10);

            this.sound.play('sfx-bonus-point-count');

            if(last) {
                this.time.delayedCall(500, () => {
                    this.countingAmount--;
                });
            }
        });
    }

    markLuckyBonusUrnAmount(urn, delay) {
        this.time.delayedCall(delay, () => {
            this.explodeWinCounterFx(urn.amount);

            this.sound.play('sfx_bonus_value_win');
            
            this.bonus2Container.setChildLocalAlpha(urn.winCounterFxLoop, 1);
            urn.winCounterFxLoop.play('win_counter_fx_loop');
            
            urn.amount.setStyle(this.fonts.urnsAmounts3);

            this.customHelper.applyDynamicFontSize(urn.amount, 180);
    
            this.tweens.add({
                targets: urn.amount,
                scale: 1.3,
                ease: 'Power0',
                yoyo: 1,
                duration: 150,
                delay: 0,
                onComplete: () => {
                    if(delay > 0) {
                        this.bonus2PicksFinished++;
                    }

                    if(this.bonus2PicksFinished === this.request.scenario.bonus_2.picks.length) {
                        this.finishBonus2();
                    }
                }
            });
        });
    }

    finishBonus2() {
        let tweenOutItems = [];
        let fillableIndex = 0;
        
        for (let [rowIndex, row] of Object.entries(this.bonus2Rows)) {
            for (let [urnKey, urn] of Object.entries(row.urns)) {
                tweenOutItems.push(urn.amount);
                tweenOutItems.push(urn.winCounterFxLoop);
                
                this.customHelper.removeClickable(urn);

                if(!urn.opened) {
                    this.tweens.add({
                        targets: urn,
                        y: urn.y + 400,
                        ease: 'Power0',
                        duration: 500,
                        delay: 0
                    });
                    
                    urn.amount.setText(General.format_currency(this.request.scenario.bonus_2['fill'][fillableIndex].amount, Math.round(this.request.scenario.bonus_2['fill'][fillableIndex].amount) == this.request.scenario.bonus_2['fill'][fillableIndex].amount));
                    this.customHelper.applyDynamicFontSize(urn.amount, 180);
                    urn.amount.setScale(0);
                    this.bonus2Container.setChildLocalAlpha(urn.amount, 1);
                    
                    this.tweens.add({
                        targets: urn.amount,
                        scale: 1,
                        ease: 'Power0',
                        duration: 500,
                    });

                    fillableIndex++;
                }
            }
        }
        
        this.tweens.add({
            targets: tweenOutItems,
            alpha: 0,
            ease: 'Power0',
            duration: 500,
            delay: 1000,
            onComplete: () => {
                this.tweenOutBonus2();
            }
        });
    }

    bigWinPositioner() {
        if(!this.bigWinContainer) {
            return;
        }

        this.bigWinContainer.setX(this.cameras.main.centerX).setY(this.cameras.main.centerY);

        if(this.bigWinAmountContainer) {
            this.bigWinAmountContainer
                .setX(this.bigWinContainer.x + this.bigWin.x)
                .setY(this.bigWinContainer.y + this.bigWin.y + this.bigWin.displayHeight / 2 + 30);
        }

        if(this.bigWinCoinsParticles) {
            this.bigWinCoinsParticles.setX(0).setY(this.cameras.main.height / 2 + 200);
            
            this.bigWinDustParticles.setX(this.bigWinCoinsParticles.x).setY(this.bigWinCoinsParticles.y);
            this.bigWinFlyingSymbolsParticles.setX(this.bigWinCoinsParticles.x).setY(this.bigWinCoinsParticles.y);
        }
    }

    regularWinPositioner() {
        if(!this.regularWinContainer) {
            return;
        }

        this.regularWinAmountContainer.setX(this.cameras.main.centerX).setY(this.cameras.main.centerY);
        this.regularWinContainerParticles.setX(this.cameras.main.centerX).setY(this.cameras.main.centerY);
        this.regularWinContainer.setX(this.cameras.main.centerX).setY(this.cameras.main.centerY);
    }

    gamePositioner() {
        if(!this.spritesReady) {
            return;
        }

        if(this.alignGrid) {
            this.alignGrid.destroy();
            delete this.alignGrid;
        }
        
        this.alignGrid = new AlignGrid({
            'scene': this,
            'cols': 21,
            'rows': 21
        });

        if(this.backLight.tween && this.backLight.tween.isPlaying()) {
            this.backLight.tween.complete();
        }
        //this.alignGrid.showNumbers();

        
        if(this.raysBase && this.raysBase.tween && this.raysBase.tween.isPlaying()) {
            this.raysBase.tween.complete();
        }

        if(this.bigWin && this.bigWin.tween && this.bigWin.tween.isPlaying()) {
            this.bigWin.tween.complete();
        }

        if(this.orientationIsSetToPortrait()) {
            this.bg.setTexture('bg_portrait');
            this.frame.setTexture('symbols_frame_portrait');
            
            this.curtainsLeft.setAlpha(0);
            this.curtainsRight.setAlpha(0);
            this.curtainsLeft.stop();
            this.curtainsRight.stop();

            this.curtainsLeftPortrait.setX(0).setY(0);
            this.curtainsRightPortrait.setX(this.cameras.main.width).setY(0);
            this.curtainsLeftPortrait.play('curtains_left_portrait');
            this.curtainsRightPortrait.play('curtains_right_portrait');
            this.curtainsLeftPortrait.setAlpha(1);
            this.curtainsRightPortrait.setAlpha(1);

            this.alignGrid.placeAtIndex(135, this.firstColumnContainer, 70, -20);
            this.alignGrid.placeAtIndex(240, this.secondColumnContainer, 70, -15);
            this.alignGrid.placeAtIndex(94, this.frame);
            this.bonus2Rows[0].setTexture('step_1_portrait');
            this.alignGrid.placeAtIndex(409, this.bonus2Container, 0, 40);
            this.alignGrid.placeAtIndex(325, this.bonus2WonText, 0, 0);
            
            this.backLight.setTexture('back_light_portrait');
            this.frontLight.setTexture('front_light_portrait');
        
            this.alignGrid.placeAtIndex(10, this.backLight, 0, -40);
            this.alignGrid.placeAtIndex(10, this.frontLight, 0, -40);
            this.multiplierStopFx.setScale(0.6);
            this.alignGrid.placeAtIndex(50, this.multiplierStopFx, -10, 25);
        } else {
            this.bg.setTexture('bg');
            this.frame.setTexture('symbols_frame');
            
            this.curtainsLeftPortrait.setAlpha(0);
            this.curtainsRightPortrait.setAlpha(0);
            this.curtainsLeftPortrait.stop();
            this.curtainsRightPortrait.stop();

            this.curtainsLeft.setX(0).setY(0);
            this.curtainsRight.setX(this.cameras.main.width).setY(0);
            this.curtainsLeft.play('curtains_left');
            this.curtainsRight.play('curtains_right');
            this.curtainsLeft.setAlpha(1);
            this.curtainsRight.setAlpha(1);

            this.alignGrid.placeAtIndex(174, this.firstColumnContainer, 5, 25);
            this.alignGrid.placeAtIndex(182, this.secondColumnContainer, -5, 25);
            this.multiplierStopFx.setScale(1);
            this.alignGrid.placeAtIndex(71, this.multiplierStopFx, 65, 5);
            this.backLight.setTexture('back_light');
            this.frontLight.setTexture('front_light');
            this.alignGrid.placeAtIndex(136, this.frame);
            this.bonus2Rows[0].setTexture('step_1');
            this.alignGrid.placeAtIndex(409, this.bonus2Container, 0, 20);
            
            this.bonus2WonText
                .setX(this.bonus2WonFrame.displayWidth / 2 + 70)
                .setY(this.bonus2WonText.displayHeight / 2 + 10);
        
            this.alignGrid.placeAtIndex(10, this.backLight, 0, -20);
            this.alignGrid.placeAtIndex(10, this.frontLight, 0, -20);
        }

        this.bonus2WonFrame
            .setX(this.bonus2WonText.x)
            .setY(this.bonus2WonText.y + this.bonus2WonText.height / 2 + this.bonus2WonFrame.height / 2 - 10);
            
        this.bonus2WonAmount
            .setX(this.bonus2WonFrame.x)
            .setY(this.bonus2WonFrame.y);

        this.regularWinPositioner();
        this.bigWinPositioner();

        this.alignGrid.placeAtIndex(10, this.logo, 0, -15);
        this.alignGrid.placeAtIndex(136, this.multiplierFrame);
        
        this.multiplierFrame
            .setX((this.frame.x - this.frame.displayWidth / 2) + this.multiplierFrame.displayWidth / 2 + 15)
            .setY(this.frame.y - 50);
        
        this.multiplier
            .setX(this.multiplierFrame.x)
            .setY(this.multiplierFrame.y);

        this.scrollIndicator
            .setX((this.frame.x + this.frame.displayWidth / 2) - this.scrollIndicator.originalWidth / 2 - 15)
            .setY(this.multiplierFrame.y);
        
        this.scrollMultiplier
            .setX(this.scrollIndicator.x + this.scrollIndicator.originalWidth / 3 - 20)
            .setY(this.scrollIndicator.y + this.scrollIndicator.originalHeight / 3);

        this.urnFrame
            .setX(this.scrollIndicator.x - this.scrollIndicator.originalWidth - 15)
            .setY(this.multiplierFrame.y);

        this.urnFrameActive
            .setX(this.urnFrame.x)
            .setY(this.urnFrame.y);

        this.urnMultiplier
            .setX(this.urnFrame.x + this.urnFrame.originalWidth / 3 - 20)
            .setY(this.scrollMultiplier.y);

        this.urnFrameActive2
            .setX(this.cameras.main.width - this.urnFrameActive2.displayWidth / 2 - 30)
            .setY(this.urnFrameActive2.displayHeight / 2 + 30);

        this.urnMultiplier2
            .setX(this.urnFrameActive2.x + this.urnFrameActive2.displayWidth / 3 - 30)
            .setY(this.urnFrameActive2.y + this.urnFrameActive2.displayHeight / 4);

            let startX = 0;
            let currentX = startX;
            let startY = 0;
            let currentY = startY;
            
        for (var [i, item] of Object.entries(this.itemsRows)) {
            let firstColumn = i < 3;

            let actualColumnContainer = firstColumn ? this.firstColumnContainer : this.secondColumnContainer;

            if(item.slider.tween && item.slider.tween.isPlaying()) {
                item.slider.tween.complete();
            }

            item.slider.setOrigin((firstColumn && ! this.orientationIsSetToPortrait() ? 1 : 0 ), 0.5);    
            item.sliderWinFrame.setOrigin((firstColumn && ! this.orientationIsSetToPortrait() ? 1 : 0 ), 0.5);    
            item.sliderHover.setOrigin((firstColumn && ! this.orientationIsSetToPortrait() ? 1 : 0 ), 0.5);    
            
            actualColumnContainer.setChildLocalPosition(item.slider, firstColumn && ! this.orientationIsSetToPortrait() ? item.slider.width / 2 : -(item.slider.width / 2), currentY);
                
            item.slider.originalX = item.slider.x;
            item.slider.originalY = item.slider.y;
            item.slider.originalRexX = item.slider.rexContainer.x;
            item.slider.originalRexY = item.slider.rexContainer.y;

            if(item.slider.slidedOut) {
                let toX = item.slider.originalRexX + (item.columnIndex === 1 && ! this.orientationIsSetToPortrait() ? item.slider.displayWidth / 2 : -(item.slider.displayWidth / 2));

                actualColumnContainer.setChildLocalPosition(item.slider, toX, currentY);
            }

            actualColumnContainer.setChildLocalPosition(item.sliderWinFrame, item.slider.originalRexX + (firstColumn && ! this.orientationIsSetToPortrait() ? 15 : -15), currentY);
            actualColumnContainer.setChildLocalPosition(item.sliderHover, item.slider.originalRexX + (firstColumn && ! this.orientationIsSetToPortrait() ? 6 : -6), currentY);

            if(!this.orientationIsSetToPortrait()) {
                item.slider.flipX = !firstColumn; 
                item.sliderWinFrame.flipX = !firstColumn; 
                item.sliderHover.flipX = !firstColumn; 
            } else {
                item.slider.flipX = true; 
                item.sliderWinFrame.flipX = true; 
                item.sliderHover.flipX = true; 
            }

            item.slider.maskShape
                .setX(item.slider.originX == 0 ? item.slider.originalX : item.slider.originalX - item.slider.width)
                .setY(item.slider.originalY - item.slider.displayHeight / 2);

            let amountX = item.slider.originalRexX + (firstColumn && ! this.orientationIsSetToPortrait() ? -(item.slider.width / 2 + 70) : item.slider.width / 2 + 70);

            item.amount.setOrigin((firstColumn && ! this.orientationIsSetToPortrait() ? 1 : 0 ), 0.5)    

            actualColumnContainer.setChildLocalPosition(item.amount, amountX, currentY);

            const middleOfAmount = item.amount.rexContainer.x + (item.amount.displayWidth / 2 * (item.amount.originX === 0 ?  1 :  -1));
    
            actualColumnContainer.setChildLocalPosition(item.winCounterFxLoop, middleOfAmount, currentY);
            actualColumnContainer.setChildLocalPosition(item.winCounterFx, middleOfAmount, currentY);

            if(! this.orientationIsSetToPortrait() && firstColumn) {
                for(let j = 0; j < 3; j++) {
                    actualColumnContainer.setChildLocalPosition(item.symbols[j].winFxLoop, currentX, currentY);
                    actualColumnContainer.setChildLocalPosition(item.symbols[j].symbolsShuffle, currentX, currentY);
                    actualColumnContainer.setChildLocalPosition(item.symbols[j].symbol, currentX, currentY);
                    actualColumnContainer.setChildLocalPosition(item.symbols[j].winCounterFx, currentX, currentY);
                    actualColumnContainer.setChildLocalPosition(item.symbols[j].scarabAppear, currentX, currentY);
                    actualColumnContainer.setChildLocalPosition(item.symbols[j].scarabHover, currentX, currentY);
                    //item.symbols[j].scarabAppear.setX(currentX).setY(currentY);
                                                                                                                               
                    currentX += (firstColumn && !this.orientationIsSetToPortrait() ? item.symbols[j].scarabAppear.originalWidth - 15 : -(item.symbols[j].scarabAppear.originalWidth) + 15);
                }
            } else {
                for(let j = 2; j >= 0; j--) {
                    actualColumnContainer.setChildLocalPosition(item.symbols[j].winFxLoop, currentX, currentY);
                    actualColumnContainer.setChildLocalPosition(item.symbols[j].symbolsShuffle, currentX, currentY);
                    actualColumnContainer.setChildLocalPosition(item.symbols[j].symbol, currentX, currentY);
                    actualColumnContainer.setChildLocalPosition(item.symbols[j].winCounterFx, currentX, currentY);
                    actualColumnContainer.setChildLocalPosition(item.symbols[j].scarabAppear, currentX, currentY);
                    actualColumnContainer.setChildLocalPosition(item.symbols[j].scarabHover, currentX, currentY);
                    //item.symbols[j].scarabAppear.setX(currentX).setY(currentY);
                                                                                                                               
                    currentX += (firstColumn && !this.orientationIsSetToPortrait() ? item.symbols[j].scarabAppear.originalWidth - 15 : -(item.symbols[j].scarabAppear.originalWidth) + 15);
                }
            }
            
            currentX = startX;

            currentY += item.symbols[0].scarabAppear.originalHeight + 5;

            if(parseInt(i) === 2) { 
                currentY = startY;
            }
        }
        
        let prevRow = false;

        for(let i = 0; i <= 3 ; i++) {
            if(this.bonus2Rows[i].tween && this.bonus2Rows[i].tween.isPlaying()) {
                this.bonus2Rows[i].tween.complete();
            }

            this.bonus2Container.setChildLocalPosition(this.bonus2Rows[i], 0, prevRow ? (prevRow.rexContainer.y - prevRow.displayHeight + 80) : 0);
            this.bonus2Rows[i].originalX = this.bonus2Rows[i].x;
            this.bonus2Rows[i].originalY = this.bonus2Rows[i].y;


            let stepX = 188;
            let startX = prevRow ? prevRow.urns[0].rexContainer.x + stepX / 2 : -284;

            prevRow = this.bonus2Rows[i];

            for(let j = 0; j <= (3 - i); j++) {
                this.bonus2Container.setChildLocalPosition(this.bonus2Rows[i].urns[j], startX, (this.bonus2Rows[i].rexContainer.y - this.bonus2Rows[i].displayHeight) + 43);
                this.bonus2Container.setChildLocalPosition(this.bonus2Rows[i].urns[j].amount, startX, (this.bonus2Rows[i].urns[j].rexContainer.y - this.bonus2Rows[i].urns[j].displayHeight / 2));
                this.bonus2Container.setChildLocalPosition(this.bonus2Rows[i].urns[j].winCounterFxLoop, this.bonus2Rows[i].urns[j].amount.rexContainer.x, this.bonus2Rows[i].urns[j].amount.rexContainer.y);
                this.bonus2Container.setChildLocalPosition(this.bonus2Rows[i].urns[j].over, this.bonus2Rows[i].urns[j].rexContainer.x, this.bonus2Rows[i].urns[j].rexContainer.y);
                this.bonus2Rows[i].urns[j].originalX = this.bonus2Rows[i].urns[j].x;
                this.bonus2Rows[i].urns[j].originalY = this.bonus2Rows[i].urns[j].y;
                startX += stepX;
            }
        }


        /*for(let i = 0; i < 6; i++) {this.drawLine(this.multiplier.x, this.multiplier.y, this.itemsRows[i].amount.x, this.itemsRows[i].amount.y)
            for(let j = 0; j < 3; j++) {

                this.drawLine(this.multiplier.x, this.multiplier.y, this.itemsRows[i].symbols[j].scarabAppear.x, this.itemsRows[i].symbols[j].scarabAppear.y)
                
                
                this.drawLine(this.itemsRows[i].symbols[j].scarabAppear.x, this.itemsRows[i].symbols[j].scarabAppear.y, this.urnFrame.x, this.urnFrame.y)
            }
        }*/
        
    }

    properties() {
        this.fonts = {
            amount: {
                fontFamily: 'Cambria',
                fontSize: '54px',
                fontStyle: 'normal',
                color: '#EEB625',
                stroke: '#4B1807',
                strokeThickness: 7,
                align: 'center'
            },
            amount2: {
                fontFamily: 'Cambria',
                fontSize: '54px',
                fontStyle: 'normal',
                color: '#fff',
                stroke: '#DEB35C',
                strokeThickness: 5,
                align: 'center'
            },
            amount3: {
                fontFamily: 'Cambria',
                fontSize: '58px',
                fontStyle: 'bold',
                color: '#fff',
                stroke: '#DEB35C',
                strokeThickness: 3,
                align: 'center'
            },
            miniMultiplier: {
                fontFamily: 'Cambria',
                fontSize: '50px',
                fontStyle: 'normal',
                color: '#fff',
                stroke: '#DEB35C',
                strokeThickness: 5,
                align: 'center',
                shadow: { stroke: true, blur: 20, fill: true, color: '#DEB35C' },
                padding: { top: 20, bottom: 20, left: 20, right: 20 }
            },
            largeMultiplier: {
                fontFamily: 'Cambria',
                fontSize: '70px',
                fontStyle: 'normal',
                color: '#fff',
                stroke: '#DEB35C',
                strokeThickness: 5,
                align: 'center',
                shadow: { stroke: true, blur: 5, fill: true, color: '#DEB35C' },
                padding: { top: 20, bottom: 20, left: 20, right: 20 }
            },
            xlMultiplier: {
                fontFamily: 'Cambria',
                fontSize: '115px',
                fontStyle: 'normal',
                color: '#fff',
                stroke: '#DEB35C',
                strokeThickness: 9,
                align: 'center',
                shadow: { stroke: true, blur: 20, fill: true, color: '#DEB35C' },
                padding: { top: 20, bottom: 20, left: 20, right: 20 }
            },
            bonus2WonText: {
                fontFamily: 'Cambria',
                fontSize: '60px',
                fontStyle: 'normal',
                color: '#fff',
                stroke: '#DEB35C',
                strokeThickness: 5,
                align: 'center',
                wordWrap: { width: 50 },
                shadow: { stroke: true, blur: 5, fill: true, color: '#DEB35C' },
                padding: { top: 20, bottom: 20, left: 20, right: 20 }
            },
            multiplier: {
                fontFamily: 'Cambria',
                fontSize: '90px',
                fontStyle: 'normal',
                color: '#fff',
                stroke: '#DEB35C',
                strokeThickness: 5,
                align: 'center',
                shadow: { stroke: true, blur: 20, fill: true, color: '#DEB35C' },
                padding: { top: 20, bottom: 20, left: 20, right: 20 }
            },
            urnsAmounts: {
                fontFamily: 'Cambria',
                fontSize: '60px',
                fontStyle: 'normal',
                color: '#794717',
                stroke: '#d7a679',
                strokeThickness: 5,
                align: 'center'
            },
            urnsAmounts2: {
                fontFamily: 'Cambria',
                fontSize: '60px',
                fontStyle: 'normal',
                color: '#fff',
                stroke: '#DEB35C',
                strokeThickness: 5,
                align: 'center',
                shadow: { stroke: true, blur: 7, fill: true, color: '#DEB35C' },
                padding: { top: 40, bottom: 40, left: 40, right: 40 }
            },
            urnsAmounts3: {
                fontFamily: 'Cambria',
                fontSize: '70px',
                fontStyle: 'bold',
                color: '#fff',
                stroke: '#DEB35C',
                strokeThickness: 3,
                align: 'center',
                shadow: { stroke: true, blur: 7, fill: true, color: '#DEB35C' },
                padding: { top: 40, bottom: 40, left: 40, right: 40 }
            },
        }
    }
}

startGame(GameScene);